import { ModalProps } from 'antd';
import GuideDialog from './NewbieGuideDialog';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';

export interface LazadaAuthShopDialogProps extends ModalProps {
  isConfigService: boolean;
  onConfigService: (e: any) => void;
  platform: General.PlatformUpperCaseTunnel;
  initialStoreType?: IM_API.Admin.StoreType;
  initialRegion?: General.UpperCaseRegion;
  initialDepartmentIds?: number[];
}

const TiktokAuthShopDialog = (props: LazadaAuthShopDialogProps) => {
  const { t } = useTranslate();
  const { platform, ...otherProps } = props;
  const title = useMemo(() => {
    let title = t('authShop.添加TikTok店铺');
    if (platform === 'TIKTOK_US') {
      title = title.replace('TikTok', 'TikTok US');
    }
    return title;
  }, [t, platform]);

  return (
    <GuideDialog
      defaultPlatform={platform?.toLowerCase() as General.Platform}
      defaultTitle={title}
      {...otherProps}
      closable
      maskClosable={false}
    />
  );
};

export default TiktokAuthShopDialog;
